import { render, staticRenderFns } from "./r-smart-offer-dialog.vue?vue&type=template&id=c2f061ec&scoped=true"
import script from "./r-smart-offer-dialog.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-smart-offer-dialog.vue?vue&type=style&index=0&id=c2f061ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f061ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2f061ec')) {
      api.createRecord('c2f061ec', component.options)
    } else {
      api.reload('c2f061ec', component.options)
    }
    module.hot.accept("./r-smart-offer-dialog.vue?vue&type=template&id=c2f061ec&scoped=true", function () {
      api.rerender('c2f061ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/r-smart-offer-dialog.vue"
export default component.exports